// Piloto de producción 4.0.0 (context/runbook_produccion_piloto.md §2.2 y
// §2.3, fase A2). Textos y reglas puras de los dos avisos del piloto; los
// componentes que los muestran (FranjaPiloto, EstadoRedesForm) importan de
// acá para que un .tsx exporte solo componentes.

/** Franja fija de toda la app con MODO_PILOTO=1 (GET /api/health → `piloto`). */
export const FRANJA_PILOTO_TITULO = 'Piloto de RedeApp 4.0';
export const FRANJA_PILOTO_TEXTO =
  'lo que cargues acá se borra al pasar a la versión definitiva. Seguí trabajando en la PowerApp.';

/** Mismo texto que el 422 del backend (middleware/escritura-lista-cc.ts). */
export const AVISO_ESCRITURA_LISTA_CC_OFF =
  'En el piloto el estado de redes no se escribe en la Lista CC: se cambia desde la PowerApp.';
/** Complemento del aviso en el diálogo: el cron de maestros trae el cambio. */
export const AVISO_ESCRITURA_LISTA_CC_OFF_DETALLE = 'RedeApp toma el cambio de SharePoint en hasta 30 minutos.';

/** ¿Mostrar la franja del piloto? Solo con `piloto: true` explícito: sin la
 *  variable el backend ni manda el campo, y mientras /api/health no respondió
 *  (o falló) no se muestra nada. */
export function esModoPiloto(health: { piloto?: boolean } | null | undefined): boolean {
  return health?.piloto === true;
}

/** ¿El diálogo «Estado de redes» deja cambiar el estado? Solo se deshabilita
 *  con `escrituraHabilitada: false` explícito (GET /api/obras/:cc/estado-redes):
 *  si el campo faltara, se deja intentar y el backend decide (su 422 trae el
 *  mismo texto, que sale en el toast). */
export function escrituraListaCCHabilitada(contexto: { escrituraHabilitada?: boolean } | null | undefined): boolean {
  return contexto?.escrituraHabilitada !== false;
}
